export const SystemFiltersEndpoint = {
  LOAD: '/default/index/load-system-filters',
  RESET: '/default/index/reset-system-filters',
};
